export default {"src":"/_next/static/media/map.1ab5714b.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};